module.exports = __webpack_public_path__ + "static/img/aboutUs.38b2ce53.png";